import React from 'react'
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { ToastContainer } from 'react-toastify';
import { hostTitle, isHostProactive, domainName } from '../../../config/ui';
import {
  // getToken,
  authContext
} from '../../../config/adalConfig'

import Content from '../components/Content';
import UiValidate from '../../../components/forms/validation/UiValidate'
import { logout } from '../../../store/current-user/CurrentUserActions'
import store from '../../../store/configureStore'

import { signIn } from "../../../store/auth/AuthActions";


class Login extends React.Component {
  azureLogin(e) {
    e.preventDefault();

    // if (!getToken()) {
    logout();
    authContext.login();
    // }
  }

  onSubmit(e) {
    e.preventDefault();
    const $form = $(this.refs.form);
    const $email = $(this.refs.email);
    const $password = $(this.refs.password);
    if ($form.data('validator')) {
      if ($form.valid()) {
        store.dispatch(signIn($email.val(), $password.val()));
      }
    }
  }

  render() {
    const { auth } = this.props;
    let error = null;
    if (auth && auth.signinMeta) {
      if (auth.signinMeta.status === 401) {
        error = 'User not found or incorrect password.';
      }
    }

    let buttonClass = "btn-danger";
    let signInButton = "btn-primary";
    let forgotPasswordClass = "note";
    if (isHostProactive())
    {
      buttonClass = "btn-custom";
      signInButton = "btn-primary-custom";
      forgotPasswordClass = "note-custom";
    }


    return (
      <div id="extr-page">
        <Helmet title={`Sign In – ${hostTitle()}`} />
        <header id="header" className="animated fadeInDown">

          <div id="logo-group">
            <span id="logo"> <img src={`assets/img/${domainName()}logo.png`} alt="SmartAdmin" /> </span>
          </div>

          <span id="extr-page-header-space"> <span className="hidden-mobile hiddex-xs">Need an account?</span>&nbsp;<a
            href="#/register" className={`btn ${buttonClass}`}>Create account</a> </span>

        </header>
        <div id="main" role="main" className="animated fadeInDown">

          <div id="content" className="container">
            <div className="row">
              <Content className="col-xs-12 col-sm-12 col-md-7 col-lg-8 hidden-xs hidden-sm" />
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 padding-top-15">
                <h6 className="text-center">Proactive MD Employees - Login using the button below.</h6>
                <br/>
                <ul className="list-inline text-center">
                  <li>
                    <a href="#login" onClick={this.azureLogin}>
                      <img
                        src="assets/img/EmployeeLogin.png"
                        alt="Login Microsoft"
                      />
                    </a>
                  </li>
                </ul>
                <br />
                <h5 className="text-center"> - Or - </h5>
                <br />
                <h6 className="text-center">If you're not Proactive MD Employee, please use the button below to Log In or register for an Account.</h6>
                <br />
                <ul className="list-inline text-center">
                  <li>
                    <a href="#/signin" >
                      <img
                      src="assets/img/NonEmployeeLogin.png"
                      alt="Login"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    )
  }
}

export default connect(
  state => ({ auth: state.auth }),
  dispatch => ({
    signIn: () => dispatch(signIn()),
  }),
)(Login);



// WEBPACK FOOTER //
// ./src/routes/auth/containers/Login.js